module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Wolves.2dc7e4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Wolves.jpg
// module id = IvD9
// module chunks = 0